import React from 'react'
import SocialShare from '../../../ui/SocialShare'
import Title from '../../../ui/Title'

const Share = ({
  email,
  facebook,
  google,
  linkedin,
  title,
  twitter
}) => (
  <div>
    <Title>{title}</Title>

    <SocialShare
      facebook={facebook}
      twitter={twitter}
      google={google}
      linkedin={linkedin}
      email={email}
    />
  </div>
)

export default Share



// WEBPACK FOOTER //
// ./components/container/Footer/Share/index.js